import { FC } from 'react';
import { Redirect, Route } from 'react-router';
import { CreateOrgPage } from '../organizations/CreateOrgPage';
import { useInstance } from '@meraki-internal/react-dependency-injection';
import { OrganizationsState } from '../organizations/OrganizationsState';
import { useSubscription } from '@meraki-internal/state';

export const OrganizationsRouter: FC = () => {
    const orgState = useInstance(OrganizationsState);
    useSubscription(() => orgState);

    return (
        <>
            <Route exact path="/orgs/create" render={(routeProps) => {
                return <CreateOrgPage />;
            }} />

            <Route path="/org/:orgId" render={(routeProps) => {
                const orgId = routeProps.match.params.orgId!;

                if (!orgState.getNonClientOrganizations().find(org => org.orgId === orgId)) {
                    return <Redirect to="/caremaps" />;
                }

                orgState.setActiveOrganization(orgId);

                // carry the query string over, otherwise the client list's ?user= filter is
                // dropped on the way to the org home and silently never applies
                return <Redirect to={{ pathname: '/caregiver', search: routeProps.location.search }} />;
            }} />
        </>
    );
};
